
import React from 'react';
import { Button } from "@/components/ui/button";

interface ProjectFiltersProps {
  activeTab: 'all' | 'draft' | 'completed' | 'exported';
  onTabChange: (tab: 'all' | 'draft' | 'completed' | 'exported') => void;
  projectCount: number;
}

const ProjectFilters = ({ activeTab, onTabChange, projectCount }: ProjectFiltersProps) => {
  const tabs = [
    { id: 'all', label: 'All Projects' },
    { id: 'draft', label: 'Drafts' },
    { id: 'completed', label: 'Completed' },
    { id: 'exported', label: 'Exported Videos' },
  ] as const;

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div className="flex space-x-1 bg-white/5 p-1 rounded-lg border border-white/10">
          {tabs.map((tab) => (
            <Button
              key={tab.id}
              variant="ghost"
              size="sm"
              onClick={() => onTabChange(tab.id)}
              className={`${
                activeTab === tab.id
                  ? 'bg-purple-600 text-white hover:bg-purple-700'
                  : 'text-gray-300 hover:text-white hover:bg-white/10'
              } transition-all duration-200`}
            >
              {tab.label}
            </Button>
          ))}
        </div>
        
        <div className="text-sm text-gray-400">
          {projectCount} {projectCount === 1 ? 'project' : 'projects'}
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;
